import React from "react";
import MessageBox from "./MessageBox";
import PatientCard from "./PatientCard";

const PatientList = (props: any) => {
  return (
    <div className="patient-list">
      {props.list.length > 0 ? (
        <>
          {props.list.map((patient: any, index: number) => {
            return (
              <div className="mb-4" key={`result-${index}`}>
                <PatientCard data={patient} />
              </div>
            );
          })}
        </>
      ) : (
        <MessageBox message_key={props.isAdvSearch? "no_result" : "no_record"} />
      )}
    </div>
  );
};

export default PatientList;
